<script setup lang="ts">
import { ParagraphTable } from '~/api/graphql/generated'

defineProps<{
  entity: ParagraphTable
}>()
</script>

<template>
  <Section>
    <div class="t-10 t-o-1 tl-8 tl-o-0">
      <TableWithFade :content="entity.fieldTable?.processed || ''" class="table text-xsmall" />
    </div>
  </Section>
</template>
<style scoped lang="scss">
.table {
  :deep(table) {
    width: auto !important;
    border-collapse: collapse;
    border: none;

    display: block;
    max-width: -moz-fit-content;
    max-width: fit-content;

    tbody > tr:first-child {
      td,
      th {
        border-bottom: 1px solid var(--c-line-light);
      }
    }

    td,
    th {
      @include fluid(padding-block, 12px, 16px);
      @include fluid(padding-right, 24px, 32px);
      border: none;
      border-bottom: 1px solid var(--c-line-light);
      &:last-child {
        padding-right: 0;
      }
    }
    th {
      text-transform: uppercase;
      color: var(--c-primary);
      text-align: left;
      padding: 0;
      @include fluid(padding-bottom, 12px, 16px);
      @include fluid(padding-right, 24px, 32px);
    }

    td {
      vertical-align: top;
      @include fluid(min-width, 60px, 100px);
    }

    tbody > tr:first-child {
      td,
      th {
        border-bottom: 1px solid var(--c-line-medium);
      }
    }

    caption {
      text-align: left;
      margin-bottom: 16px;
    }
  }

  :deep(p) {
    color: var(--c-text-light);
    line-height: 140%;
    letter-spacing: 0.5px;
    @include fluid-ts-ds(font-size, 16px, 18px);
  }
}
</style>
